module.exports = __webpack_public_path__ + "static/media/bkst_logo_old.f341ad0c.png";